import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
/* eslint-disable react-hooks/rules-of-hooks */
import { JSX } from '@redneckz/uni-jsx';
import { useJSONRef } from '../hooks/useJSONRef/useJSONRef.js';
import { extractContent } from './extractContent.js';
export function UniBlock(InputComponent, meta = {}) {
    const OutputComponent = JSX((props) => {
        const content = useJSONRef(extractContent(props), props.options?.page?.fallback);
        return _jsx(InputComponent, { ...props, ...content });
    });
    Object.assign(OutputComponent, meta);
    return OutputComponent;
}
//# sourceMappingURL=UniBlock.js.map